import angular from 'angular';
import constants from 'app/constants';
import {
  riskDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './delete-risk-confirm-dialog.controller';
import template from './delete-risk-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId, risk, asset, process, isEditProcessDialog,
    isApproveProcessDialog,
    isPraProcessMain,
    riskType,
    showSyncAsset,
    assetType,
    isEditAssetDialog
  }) {
    return {
      controller,
      controllerAs: 'deleteRiskConfirmDialogVM',
      locals: {
        customerId,
        risk,
        asset,
        process,
        isEditProcessDialog,
        isApproveProcessDialog,
        isPraProcessMain,
        riskType,
        showSyncAsset,
        assetType,
        isEditAssetDialog
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.risk.deleteRiskConfirmDialog', [
  alerts,
  riskDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('deleteRiskConfirmDialog', dialogService)
  .name;
